// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/high-level-control-areas.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/high-level-control-areas/high-level-control-areas.js';

mount([g0]);
